// custom-toastr.module.ts
import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  imports: [
    ToastrModule.forRoot({
      enableHtml: true,
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
      positionClass: 'toast-top-right',
      timeOut: 7000,
      maxOpened: 5,
      newestOnTop: false,
      autoDismiss: false
    })
  ],
  exports: [ToastrModule]
})
export class CustomToastrModule {}
